<template>
  <div
    v-if="user"
    class="grid-x grid-margin-x"
    style="background-color:#fff">
    <!-- Select membership -->
    <section class="package-section">
      <div class="grid-x grid-margin-x">
        <div class="cell small-12">
          <div class="cart-section-divider twentyone">

                      <!-- <h2>Kom igång med ditt byte!</h2> -->
            <h1 class="activate-heading">Aktivera ditt medlemskap!</h1>
            <div class="usp-list" v-if="true">
            <div>Obegräsnat med likes!</div>
            <div><span>Direkt- och trinagelbyten!</span></div>
            <div><span>Din annons <nobr>syns överst!</nobr></span></div>
            </div>
<p>Om du är seriös i ditt bostadsbyte kand du aktivera ditt medlemskap för att få tillgång till alla funktioner. Du kan anmäla intresse på så många bostäder du vill, och din annons syns först.</p>
<p>Du är i gott sällskap. Tusentals andra har använt <strong>BytBostad</strong> sedan starten 2010.</p>


            <!-- <p></p> -->


            <!-- <div>
              {{ swishPaymentID }}
              <input type="text" v-model="swishPaymentID" />
              <button @click.prevent="checkPayment({id: swishPaymentID})">Check payment</button>
            </div> -->

            <!-- <div>
              {{ swishToken }}


              <button @click.prevent="openSwishApp">Open Swish</button>
            </div> -->

            <div class="usp-container">

<div v-if="false">
    <p>För att kunna markera bostäder som intressanta på BytBostad måste du aktivera ditt konto. <nobr>När du akriverat ditt konto</nobr> kommer du att kunna markera annonser som intressanta, <nobr>och kunna få till ett byte!</nobr></p>     
</div>

<div class="usp-list" v-if="false">
  <div>Obegräsnat med likes!</div>
  <div><span>Direkt- och trinagelbyten!</span></div>
  <div><span>Din annons <nobr>syns överst!</nobr></span></div>
</div>

            </div>

           
            <!-- STUFF -->
          <div class="check-tag-wrap">
          <div
          v-show="membership.payment"
            class="check-tag "
            :class="{ active: true }"
            @click.prevent="resetPayment"
            style="--color-active:var(--color-secondary);"
            >
            <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div class="check-label">
              {{ nicePaymentName(membership.payment) }}
            </div>
          </div>


          <div
          v-show="membership.period"
            class="check-tag "
            :class="{ active: true }"
            @click.prevent="resetPeriod"
            style="--color-active:var(--color-secondary);"
            >
            <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div class="check-label">
              {{ nicePeriodName(membership.period) }}
            </div>
          </div>

          <div class="clear"></div>
        </div>

            <!-- STUFF -->





            <!-- <div style="border:2px solid red;display:flex; gap:10px;">
              <button v-if="membership.payment" @click.prevent="resetPayment">{{ nicePaymentName(membership.payment) }}</button>
              <button v-if="membership.period" @click.prevent="resetPeriod">{{ nicePeriodName(membership.period) }}</button>
            </div> -->
          <article class="package-type-wrap" v-if="false">
  
            
            <h1 style="text-decoration:underline;text-decoration-color:var(--color-secondary);">Prova <span class="highlight">gratis</span> i 15 dagar</h1>
     

<!-- <pre>{{membership}}</pre> -->
          <h3 style="color:#979797;font-size:1.1rem;">därefter <span v-if="membership.bigCities">129</span><span v-else>29</span> kr / månad</h3>


<!-- Hiding the big city checkbox for now -->
<div v-if="false">



          <ul class="membership-bigcities" v-if="true">
            <li 
            style="--color-active: green;"
            class="check-tag" :class="{ active: membership.bigCities }">
              <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div>Stockholm</div></li>
            <li 
            style="--color-active: green;"
            class="check-tag" :class="{ active: membership.bigCities }">
              <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div>Göteborg</div></li>
            <li 
            style="--color-active: green;"
            class="check-tag" :class="{ active: membership.bigCities }">
              <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div>Malmö</div></li>
            <li 
            style="--color-active: green;"
            class="check-tag" :class="{ active: membership.bigCities }">
              <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div>Uppsala</div></li>
            <li 
            style="--color-active: green;"
            class="check-tag active">
              <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div>Resten av sverige</div></li>

            
            <!-- <li  :class="{ active: membership.bigCities }">Göteborg</li>
            <li  :class="{ active: membership.bigCities }">Malmö</li> -->
            <!-- <li  :class="{ active: membership.bigCities }">Uppsala</li>
            <li class="active">Resten av sverige</li> -->
          </ul>

          
          <p v-if="membership.bigCities">Hela Sverige</p>
          <p v-if="!membership.bigCities">Intressemarkera, <strong style="color:var(--color-primary);">förutom</strong> i Stockholm, Göteborg, Malmö eller Uppsala.</p>

<div class="check-tag-wrap">
          <div
          style="--color-active: var(--color-secondary);"
            class="check-tag "
            :class="{ active: membership.bigCities }"
            @click="membership.bigCities = !membership.bigCities">
            <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div class="check-label">
              Storstad
            </div>
          </div>

          <div
                    style="--color-active: var(--color-secondary);"

            class="check-tag "
            :class="{ active: !membership.bigCities }"
            @click="membership.bigCities = !membership.bigCities">
            <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div class="check-label">
              Småstad
            </div>
          </div>
          </div>   

        
</div>

 <button :disabled="!membership.sessionId" class="button-large secondary" style="max-width:200px;justify-self:center;" @click.prevent="finalizeStripePayment">
      <!-- <img  v-show="!membership.sessionId" src="https://samherbert.net/svg-loaders/svg-loaders/oval.svg"> -->


<div class="spinner" v-show="!membership.sessionId">
<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <circle cx="50" cy="50" r="45"/>
</svg>
</div>

      <span v-show="membership.sessionId" style="line-height:34px;">Aktivera
        
        
        <!-- {{membership.sessionId}} -->
        </span></button>

        





          

<div style="padding-top:20px;" v-show="false">

   <button :disabled="!membership.sessionId" class="button-large secondary" style="max-width:200px;justify-self:center;" @click.prevent="finalizeStripePayment">
      <!-- <img  v-show="!membership.sessionId" src="https://samherbert.net/svg-loaders/svg-loaders/oval.svg"> -->


<div class="spinner" v-show="!membership.sessionId">
<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <circle cx="50" cy="50" r="45"/>
</svg>
</div>

      <span v-show="membership.sessionId" style="line-height:34px;">Aktivera
        
        
        <!-- {{membership.sessionId}} -->
        </span></button>

</div>

          </article>



<!-- <p>Det finns tre typer av medlemskap:</p> -->


<!-- <p><strong>Prova på</strong> är för dig som bara vill kika. Det kostar 199 kronor i månaden.</p> -->
     </div>
        </div>


   





        <div v-if="false" class="cell small-12 box discount" :class="{ active: membership.discount == true }" @click="membership.discount = !membership.discount">
          <!-- <h3>Vill du ha rabatt?</h3> -->
          <input id="discount" v-model.number="membership.discount" type="checkbox" name="discount">

          <div
            class="radio-wrap twoline"
            :class="{ active: membership.discount}">
            <div class="radio-box" style="border-radius:6px;"></div>
            <div class="radio-label">
              Jag vill ha rabatt <span>(Halva priset för gamla medlemmar)</span>
            </div>
            <div class="clear"></div>
          </div>

          <p>
            Eftersom du var medlem på BytBostad innan den 1 oktober 2019 ger vi dig <strong>halva priset</strong> på medlemskapet.
          </p>
        </div>




        <div class="cell small-12 medium-4 klickable" v-if="false">

          <article
            class="package-type-wrap"
            :class="{ active: membership.period == 1 }"
            @click.capture.prevent="setMembershipPeriod(1)">
            <header>
              <h3>15 dagar <span class="highlight">gratis</span> <span class="mobilpris"> {{ planPrice(1).regular }} / månad</span></h3>
            </header>
            
            <input
              id="1mon"
              v-model.number="membership.period"
              type="radio"
              name="membership"
              value="1"
              required>


            <label for="1mon">
          <span class="time">därefter  {{ planPrice(1).regular }} kr</span>

              <!-- <span
                :class="{ strike: planPrice(1).discount }"
                class="price">
                {{ planPrice(1).regular }}
              </span> -->
              <span
                v-if="planPrice(1).discount"
                class="price sale">{{ planPrice(1).discount }}</span>
                <span class="time">varje månad</span>
              <!-- <span v-if="planPrice(1).discount" class="time">Halva priset!</span>
              <span v-if="!planPrice(1).discount" class="time">Ordinarie pris</span> -->
            </label>
            <button class="button-small">
              <template v-if="membership.period == 1">
                {{ planPrice(1).regular }} kr / månad
              </template>
              <template v-else>
                Välj
              </template>
            </button>
          </article>
        </div>

       

    


        




        
      </div>


      
    </section>
    <!-- Select membership : END -->




    



       



    <!-- Select payment -->
    <section class="payment-section" v-if="true">
      <div class="grid-x grid-margin-x">
        <!-- <div v-if="showall" class="cell small-12">
          <div class="cart-section-divider">
            <h2>Betalsätt</h2>
            <p>Välj mellan kort eller Swish!</p>
          </div>
        </div> -->
        <div
        :key="'payment-chooser'"
         id="choose-payment-method" v-show="showall && !swishSubmitted && !membership.payment" class="pay-form-box" :class="{ active: !membership.payment }" style="display:flex;gap:10px;width:100%;margin-left:0.625rem;margin-right:0.625rem">

          <!-- <div class="cell small-4"> -->
            <article
              class="payment-type-wrap"
              :class="{ active: membership.payment == 'stripe' }"
              @click="membership.payment = 'stripe'">
              <header>
                <h3>Kort</h3>
              </header>
              <input
                id="payment_card"
                v-model="membership.payment"
                type="radio"
                name="payment"
                value="stripe"
                required>
              <!-- <label for="payment_card">VISA &amp; MasterCard</label> -->
              <!-- <div class="payment-logo card">
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="18"><g fill-rule="evenodd"><path d="M44 9.288c0-3.072-1.5155556-5.496-4.4122222-5.496-2.9088889 0-4.6688889 2.424-4.6688889 5.472 0 3.612 2.0777778 5.436 5.06 5.436 1.4544444 0 2.5544444-.324 3.3855555-.78v-2.4c-.8311111.408-1.7844444.66-2.9944444.66-1.1855556 0-2.2366667-.408-2.3711111-1.824h5.9766667c0-.156.0244444-.78.0244444-1.068zm-6.0377778-1.14c0-1.356.8433334-1.92 1.6133334-1.92.7455555 0 1.54.564 1.54 1.92h-3.1533334zM30.2011111 3.792c-1.1977778 0-1.9677778.552-2.3955555.936l-.1588889-.744h-2.6888889v13.992l3.0555555-.636.0122223-3.396c.44.312 1.0877777.756 2.1633333.756 2.1877778 0 4.18-1.728 4.18-5.532-.0122222-3.48-2.0288889-5.376-4.1677778-5.376zm-.7333333 8.268c-.7211111 0-1.1488889-.252-1.4422222-.564l-.0122223-4.452c.3177778-.348.7577778-.588 1.4544445-.588C30.58 6.456 31.35 7.68 31.35 9.252c0 1.608-.7577778 2.808-1.8822222 2.808zM20.7533333 3.084l3.0677778-.648V0l-3.0677778.636zM20.7533333 3.996h3.06777778v10.5H20.7533333zM17.4655556 4.884L17.27 3.996h-2.64v10.5h3.0555556V7.38c.7211111-.924 1.9433333-.756 2.3222222-.624v-2.76c-.3911111-.144-1.8211111-.408-2.5422222.888zM11.3544444 1.392l-2.98222218.624L8.36 11.628c0 1.776 1.35666667 3.084 3.1655556 3.084 1.0022222 0 1.7355555-.18 2.1388888-.396V11.88c-.3911111.156-2.3222222.708-2.3222222-1.068v-4.26h2.3222222V3.996h-2.3222222l.0122222-2.604zM3.09222222 7.044c0-.468.39111111-.648 1.03888889-.648.92888889 0 2.10222222.276 3.03111111.768v-2.82c-1.01444444-.396-2.01666666-.552-3.03111111-.552C1.65 3.792 0 5.064 0 7.188 0 10.5 4.64444444 9.972 4.64444444 11.4c0 .552-.48888888.732-1.17333333.732-1.01444444 0-2.31-.408-3.33666667-.96v2.856c1.13666667.48 2.28555556.684 3.33666667.684 2.54222222 0 4.29-1.236 4.29-3.384-.01222222-3.576-4.66888889-2.94-4.66888889-4.284z" /></g></svg>
              </div> -->
            </article>
          <!-- </div> -->

          <!-- <div class="cell small-4">
            <article
              class="payment-type-wrap"
              :class="{ active: membership.payment == 'billogram' }" @click="membership.payment = 'billogram'">
              <header>
                <h3>Faktura</h3>
              </header>
              <input
                id="payment_invoice"
                v-model="membership.payment"
                type="radio"
                name="payment"
                value="billogram">
              <label for="payment_invoice">
                Betala senare
              </label>
              <div class="payment-logo invoice">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32"><g fill-rule="evenodd"><path d="M28.4483183 21.1254237c-4.0804658 0-7.3563328-3.2329144-7.3563328-7.1347077V9.19708421c0-3.95753321-3.3333383-7.13470775-7.3563328-7.13470775-4.08046587 0-7.41380418 3.17717454-7.41380418 7.13470775v.94757839l-.8045989.2229596c-2.01149726.5016591-3.44828101 2.2853361-3.44828101 4.2919726 0 2.4525558 2.0689686 4.4034525 4.54023666 4.4034525H18.6207175c.5747135 0 1.0344843.4459192 1.0344843 1.0033182 0 .5573991-.4597708 1.0033183-1.0344843 1.0033183H6.66667662C2.98851021 21.1254237 0 18.2269487 0 14.6595948c0-2.6755154 1.72414051-5.07233126 4.25287991-6.01990963C4.54023666 3.8460534 8.67817388 0 13.6781813 0c5.2298929 0 9.4827728 4.12475292 9.4827728 9.19708421v4.73789189c0 2.8427351 2.3563254 5.1280712 5.2873642 5.1280712 2.9310389 0 5.2873643-2.2853361 5.2873643-5.1280712s-2.3563254-5.12807122-5.2873643-5.12807122c-.5747135 0-1.149427.11147981-1.6666691.27869952-.5747135.16721971-1.149427-.11147981-1.3218411-.61313895-.172414-.55739904.1149427-1.11479808.6321849-1.2820178.7471275-.22295961 1.5517264-.39017933 2.3563253-.39017933 4.0804659 0 7.3563329 3.23291448 7.3563329 7.13470778 0 3.9575332-3.3333383 7.1904476-7.3563329 7.1904476z" /><path fill-rule="nonzero" d="M4.54883721 27.8237288c0 .4338983-.02790698.65084745-.11162791.86779661-.27906977.84067796-1.08837209 1.46440678-2.06511628 1.46440678-1.2 0-2.17674418-.89491526-2.17674418-2.06101695v-4.44745763c0-.21694915.16744186-.40677966.41860465-.40677966h.13953488c.22325582 0 .41860465.16271186.41860465.40677966v1.70847458c0 .05423728.02790698.08135593.08372093.08135593.02790698 0 .02790698 0 .05581396-.02711865.19534883-.10847457.58604651-.32542372 1.03255814-.32542372.97674418 0 1.81395348.62372881 2.06511628 1.46440678.05581395.21694915.1116279.4338983.1116279.86779661v.40677966h.02790698zm-.97674419-.35254238c0-.35254237 0-.48813559-.05581395-.6779661-.13953488-.48813559-.58604651-.84067796-1.11627907-.84067796-.3627907 0-.66976744.16271186-1.00465116.35254237-.11162791.05423729-.16744186.16271186-.16744186.27118644v1.54576271c0 .62372881.53023255 1.13898305 1.17209302 1.13898305.53023256 0 .97674419-.35254237 1.11627907-.84067796.05581395-.16271187.05581395-.29830509.05581395-.67796611v-.27118644zM6.66976744 23.7016949c0 .32542373-.27906977.59661017-.61395349.59661017h-.08372093c-.33488372 0-.61395349-.27118644-.61395349-.59661017v-.08135593c0-.32542373.27906977-.59661017.61395349-.59661017h.08372093c.33488372 0 .61395349.27118644.61395349.59661017v.08135593zm-.16744186 5.91186441c0 .21694915-.16744186.40677966-.41860465.40677966h-.13953488c-.22325582 0-.41860465-.18983051-.41860465-.40677966v-3.98644068c0-.21694916.19534883-.40677966.41860465-.40677966h.13953488c.22325581 0 .41860465.1898305.41860465.40677966v3.98644068zM11.3860465 28.69152541c-.0558139-.21694916-.1116279-.40677966-.1116279-.86779661v-.40677966c0-.43389831.027907-.65084746.1116279-.86779661.2790698-.84067797 1.0883721-1.46440678 2.0651163-1.46440678.9767442 0 1.8139535.62372881 2.0651163 1.46440678.0558139.21694915.1116279.4338983.1116279.86779661v.40677966c0 .4338983-.027907.65084745-.1116279.86779661-.2790698.84067796-1.0883721 1.46440678-2.0651163 1.46440678-.9488372 0-1.7860465-.62372882-2.0651163-1.46440678zm.9767442-1.89830509c-.055814.16271187-.055814.29830509-.055814.6779661v.29830509c0 .35254237 0 .48813559.055814.6779661.1395349.48813559.5860465.84067797 1.1162791.84067797.5302325 0 .9767442-.35254238 1.116279-.84067797.055814-.16271186.055814-.29830508.055814-.6779661v-.29830509c0-.35254237 0-.48813559-.055814-.6779661-.1395348-.48813559-.5860465-.84067796-1.116279-.84067796-.5302326 0-.9767442.37966101-1.1162791.84067796zM16.3813953 28.69152541c-.0558139-.21694916-.1116279-.40677966-.1116279-.86779661v-.40677966c0-.43389831.027907-.65084746.1116279-.86779661.2790698-.84067797 1.0883721-1.46440678 2.0651163-1.46440678.5023256 0 .8093024.1898305 1.0325582.29830508l.2511628.16271186c.0279069 0 .0558139.02711865.0558139.02711865.055814 0 .0837209-.02711865.0837209-.05423729.027907-.16271186.1674419-.29830508.3627907-.29830508.2232559 0 .3627907.16271186.3627907.35254237v4.69152542c0 .94915255-.7813953 1.68135593-1.7581395 1.68135593h-.6976744c-.2232558 0-.4186047-.1898305-.4186047-.40677966v-.05423728c0-.21694916.1953489-.40677967.4186047-.40677967h.7534884c.4186046 0 .7534883-.32542372.7534883-.73220339v-.46101694c0-.05423729-.0279069-.08135594-.0837209-.08135594-.027907 0-.027907 0-.055814.02711865-.1395348.10847457-.5860465.32542373-1.0325581.32542373-1.0046512 0-1.8139535-.62372882-2.0930233-1.46440678zm.9488373-1.89830509c-.055814.16271187-.055814.29830509-.055814.6779661v.29830509c0 .35254237 0 .48813559.055814.6779661.1395348.48813559.5860465.84067797 1.116279.84067797.2511628 0 .4744186-.08135594.7255814-.21694916l.3069768-.16271186c.1395349-.08135593.1395349-.13559322.1395349-.21694915v-2.11525424c0-.10847458 0-.13559322-.1395349-.21694915-.2511628-.13559322-.6976745-.40677966-1.0325582-.40677966-.5302325 0-.9767442.37966101-1.116279.84067796z" /><path d="M22.6046512 26.57627117v3.03728814c0 .21694915-.1674419.40677966-.4186047.40677966h-.1395349c-.2232558 0-.4186046-.18983051-.4186046-.40677966v-4.04067797c0-.21694915.1395349-.35254237.3627907-.35254237.1953488 0 .3348837.10847457.3627907.29830508 0 .05423729.0279069.05423729.0837209.05423729.027907 0 .027907 0 .055814-.02711865l.2511627-.16271186c.2232559-.10847458.5302326-.29830508 1.0325582-.29830508.2232558 0 .4186046.1898305.4186046.40677966v.05423728c0 .21694916-.1953488.40677967-.4186046.40677967-.3627907 0-.7813954.24406779-1.0325582.40677966-.1395348.08135593-.1395348.13559322-.1395348.21694915z" />
                  <path fill-rule="nonzero" d="M28.4651163 29.66779659c0 .21694916-.1395349.35254238-.3627907.35254238-.2232558 0-.3627907-.16271187-.3627907-.35254238 0-.05423728-.027907-.08135593-.0837209-.08135593-.027907 0-.027907 0-.1395349.05423729-.2790698.18983051-.6976744.51525424-1.3395349.51525424h-.0837209c-.8651163 0-1.5906977-.65084746-1.5906977-1.51864407v-.05423729c0-.86779661.7255814-1.51864407 1.5906977-1.51864407h1.2c.1116279 0 .1953488-.08135593.1953488-.18983051v-.21694915c0-.40677966-.3348837-.73220339-.7534884-.73220339h-.1116279c-.3906977 0-.8651163.32542373-1.2.51525424-.0558139.05423729-.1395349.05423729-.2232558.05423729-.1395349 0-.2790698-.05423729-.3627907-.18983051l-.055814-.08135593c-.0558139-.05423729-.0558139-.13559322-.0558139-.21694916 0-.13559322.0558139-.27118644.1953488-.35254237.5581396-.32542373 1.0325582-.59661017 1.7023256-.59661017h.1116279c.9767442 0 1.7581396.73220339 1.7581396 1.68135593v2.92881356h-.027907zm-.9767442-1.57288135c0-.10847458-.0837209-.18983051-.1953488-.18983051h-1.2c-.3348838 0-.5860466.27118644-.5860466.59661017v.18983051c0 .32542373.2511628.59661017.5860466.59661017h.1953488c.3348837 0 .6418605-.16271187.9209302-.32542373l.1395349-.08135593c.1395349-.08135594.1395349-.13559323.1395349-.21694916v-.56949152z" />
                  <path d="M35.4697674 29.61355931c0 .21694915-.1953488.40677966-.4186046.40677966h-.1395349c-.2232558 0-.4186046-.18983051-.4186046-.40677966v-2.92881356c0-.40677967-.3348838-.73220339-.7534884-.73220339-.1953489 0-.4186047.10847457-.6697675.24406779-.1116279.08135593-.1395348.10847458-.1395348.16271187.0279069.13559322.0279069.24406779.0279069.35254237v2.87457627c0 .21694915-.1953488.40677966-.4186046.40677966H32.4c-.2232558 0-.4186047-.18983051-.4186047-.40677966v-2.90169491c0-.40677967-.3348837-.73220339-.7534883-.73220339-.1674419 0-.3906977.08135593-.6139535.21694915-.1395349.10847457-.1395349.13559322-.1395349.21694915v3.2c0 .21694915-.1674419.40677966-.4186046.40677966h-.1395349c-.2232558 0-.4186047-.18983051-.4186047-.40677966v-4.01355932c0-.21694915.1395349-.35254237.3627907-.35254237.1395349 0 .2511628.08135593.3348837.1898305.027907.02711865.027907.05423729.055814.05423729s.0558139 0 .0837209-.02711864c.2511628-.16271187.5302326-.32542373.8930233-.32542373.4465116 0 .8651163.13559322 1.172093.4338983.027907.02711865.055814.02711865.055814.02711865.0279069 0 .0558139 0 .0837209-.02711865.0558139-.02711864.1395349-.08135593.2790698-.16271186.2511627-.13559322.5302325-.27118644.9209302-.27118644.9767442 0 1.7581395.75932203 1.7581395 1.68135593v2.82033899h-.027907zM8.48372093 29.61355931c0 .21694915-.16744186.40677966-.41860465.40677966H7.9255814c-.22325582 0-.41860466-.18983051-.41860466-.40677966v-5.9661017c0-.21694915.19534884-.40677966.41860466-.40677966h.13953488c.22325581 0 .41860465.1898305.41860465.40677966v5.9661017zM10.4651163 29.61355931c0 .21694915-.1674419.40677966-.4186047.40677966h-.13953486c-.22325581 0-.41860465-.18983051-.41860465-.40677966v-5.9661017c0-.21694915.19534884-.40677966.41860465-.40677966h.13953486c.2232558 0 .4186047.1898305.4186047.40677966v5.9661017z" />
                </g>
                </svg>
              </div>
            </article>
          </div> -->

          <!-- <div class="cell small-4"> -->
            <article
            
              class="payment-type-wrap"
              :class="{ active: membership.payment == 'swish' }"
              @click="membership.payment = 'swish'">
              <header>
                <h3 style="margin-bottom:1rem;">Swish</h3>
              </header>
              <input
                id="payment_swish"
                v-model="membership.payment"
                type="radio"
                name="payment"
                value="swish">
              <!-- <label for="payment_swish">
                Direkt i mobilen
              </label> -->
              <!-- <div class="payment-logo swish">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="39"
                  height="33">
                  <g fill-rule="nonzero">
                    <path d="M.14343673 31.195698l.17094728-.2602208c.21978936-.3086341.47010502-.3328407.83642062-.1452396.3663156.1876011.90968374.5022868 1.67284124.5022868.6410523 0 1.0378942-.2904791 1.0378942-.7504044 0-1.2103297-3.70589282-.7564561-3.70589282-3.2981485 0-1.4523957 1.28820986-2.2209551 2.85726168-2.2209551.72892808-.0053642 1.44661148.178218 2.08189366.5325451.3357893.1754978.37852612.4841319.21978936.8169726l-.14652624.2602209c-.17705254.3509956-.45178924.3933571-.81810484.2299626-.3663156-.1633945-.81199958-.3570473-1.42252558-.3570473s-1.01347316.2602209-1.01347316.7201462c0 1.2224331 3.70589282.7443528 3.70589282 3.2739419 0 1.3071562-1.11115732 2.2754199-2.8389459 2.2754199-.89083206.007058-1.76240099-.2569748-2.49705134-.756456-.32968404-.1876011-.3663156-.5022869-.14042098-.8230243zm6.11747052-5.3193991c-.11599994-.4054605.0915789-.6777847.51284184-.6777847h.70821016c.3663156 0 .58610496.1694462.65936808.5325451l1.19663095 4.3269288c.0915789.3933572.14652624.7867143.14652624.7867143h.0305263s.0610526-.3933571.16484202-.7867143l1.25768356-4.3269288c.0732631-.344944.305263-.5204418.6776839-.5204418h.5555786c.3663156 0 .5799997.1754978.6715786.5204418l1.2454731 4.3269288c.0737061.2580299.1287926.5209321.164842.7867143h.024421s.0610526-.3933571.164842-.7867143l1.1844205-4.3269288c.0915789-.3630989.3113682-.5325451.6715786-.5325451h.6776838c.4395788 0 .6288418.2723242.5128419.6777847l-1.9170517 6.2210948c-.1037894.344944-.3357893.5083385-.6898943.5083385h-.9829469c-.3663156 0-.6044207-.1754978-.6898944-.5264935L12.07922 28.3756298c-.0749587-.2625537-.1340808-.5292982-.1770525-.7988176h-.0244211s-.0732631.4054604-.189263.7988176l-1.1294731 3.7036089c-.0915789.3509957-.3113683.5264935-.67768388.5264935h-1.0073679c-.35410508 0-.57389443-.1633945-.67768385-.5083385l-1.93536742-6.2210948zm12.32041465-.0665682c0-.3994088.2075789-.6112165.6044208-.6112165h.6471575c.3907367 0 .5983155.2118077.5983155.6112165v6.184785c0 .4054604-.2075788.6112165-.5983155.6112165h-.6471575c-.3968419 0-.6044208-.2057561-.6044208-.6112165v-6.184785zm3.0831563 5.3859673l.1770525-.2602208c.2136841-.3086341.4701051-.3328407.8303154-.1452396.3602103.1876011.9096837.5022868 1.6728412.5022868.6410523 0 1.0378942-.2904791 1.0378942-.7504044 0-1.2103297-3.7058928-.7564561-3.7058928-3.2981485 0-1.4523957 1.2882099-2.2209551 2.8572617-2.2209551.729033-.0062107 1.4469329.1774269 2.0818937.5325451.3357893.1754978.3785261.4841319.2197893.8169726l-.1465262.2602209c-.1770526.3509956-.4517893.3933571-.8242101.2299626-.3724209-.1633945-.7997891-.3570473-1.4164203-.3570473-.6166313 0-1.0134732.2602209-1.0134732.7201462 0 1.2224331 3.7058928.7443528 3.7058928 3.2739419 0 1.3071562-1.1111573 2.2754199-2.8389459 2.2754199-.8889833.00738-1.7587001-.2567375-2.4909461-.756456-.3357893-.1876011-.3724208-.5022869-.1465262-.8230243zm6.5814703-8.2968103c0-.3933571.2197893-.6112165.6166312-.6112165h.6227366c.4151576 0 .6166312.2178594.6166312.6112165v2.9955661c.0010546.2085266-.0132289.416852-.0427368.6233198h.0305263c.3663156-.7080429 1.3065256-1.4947572 2.5947355-1.4947572 1.6545255 0 2.606946.8532825 2.606946 2.8140166v4.1574827c0 .4054604-.2197893.6112165-.6166312.6112165h-.6288418c-.4090524 0-.6166313-.2057561-.6166313-.6112165v-3.7762288c0-.9016956-.2319999-1.5129122-1.1722099-1.5129122-1.3004204 0-2.1551568 1.0469353-2.1551568 2.4569694v2.8321716c0 .4054604-.2014736.6112165-.6166312.6112165h-.6227366c-.3968419 0-.6166312-.2057561-.6166312-.6112165v-9.095628zm9.0357848 1.1740199c.1709473 0 .2686314-.1089297.2686314-.2844275 0-.1754978-.0976841-.2662725-.2625262-.2662725h-.2686314v.5507h.2625262zm-.5799997-.6475264c-.0038282-.0395619.0103747-.0787503.0387265-.1068531.0283518-.0281028.0678874-.0421811.1077997-.0383865h.5006313c.3174736 0 .5250524.1997044.5250524.5083385.0080484.1979807-.1161161.377669-.305263.4417703.0222392.0277481.0407124.0582664.0549473.0907748l.2319999.447822c.0549474.102878.0244211.1633945-.0793684.1633945h-.0549473c-.0733862.0057697-.1422569-.0356775-.1709473-.102878l-.2564209-.5385968h-.2747367v.5022869c.0064386.0385214-.006267.0777557-.0341217.1053658-.0278547.0276101-.0674366.0402042-.1062993.0338221h-.0366315c-.0976842 0-.140421-.0423615-.140421-.1391879v-1.3676726zm.5433681 2.0030957c.7143154 0 1.2698941-.5749066 1.2698941-1.3071561s-.5555787-1.3071561-1.2698941-1.3071561c-.7143154 0-1.2515783.5688549-1.2515783 1.3071561 0 .7383011.5433682 1.3071561 1.2515783 1.3071561zm0-2.9168947c.856647.0521367 1.5244722.755989 1.5244722 1.6067127 0 .8507238-.6678252 1.5545761-1.5244722 1.6067128-.8730522 0-1.5751571-.7140946-1.5751571-1.6036869 0-.8895924.7021049-1.6097386 1.5751571-1.6097386zM29.3674509 11.5741781c-.0024694 3.7709623-1.8759667 7.2975841-5.0063312 9.4237855-3.1303644 2.1262013-7.1139442 2.5778143-10.6448614 1.2067934 4.3504812 1.3764935 9.0702249-.5176219 11.2430947-4.5120499 2.1728697-3.9944279 1.185442-8.96149999-2.3521921-11.83226588l2.5391137-3.13179723c2.6762976 2.16396248 4.2274614 5.41444809 4.2211763 8.84553411zM11.7872992 4.08710612c2.5675518-3.1519757 6.8799106-4.3377717 10.7246813-2.94903203C17.2255834-1.17288654 11.0256271.75000415 8.02134028 5.63228595 5.01705348 10.5145678 6.13990676 16.8425031 10.6456915 20.4220409l2.5324397-3.1159583c-4.05612172-3.2812006-4.67703331-9.18257175-1.390832-13.21897648z" />
                  </g>
                </svg>
              </div> -->
            </article>
          <!-- </div> -->
        </div>
        <!-- Card payment form -->
        <div
          v-show="membership.payment == 'old-stripe'"
          class="cell small-12">
          <div class="pay-form-box">
            <!-- <CreditCardForm ref="stripe" :stripe="stripeKey" :stripe-options="options" @stripeready="stripeComplete" @stripeerror="stripeError" @token="gotToken" /> -->

           
          </div>
        </div>
        <!-- Card payment form : END -->




        <!-- SELECT MEMBERHSIP LENGTH  -->
      <div class="membership-chooser pay-form-box" style="width:100%;" v-show="!membership.period && membership.payment === 'stripe'" :class="{ active: !membership.period }">


          <button class="button-small-checkout" :class="{ active: membership.period == 1 }"
          @click.capture.prevent="setMembershipPeriod(1)"
          >
                {{ planPrice(1).regular }} kr<wbr> / månad
               
              
            </button>

            <!-- <button class="button-small-checkout" :class="{ active: membership.period == 3 }"
                      @click.capture.prevent="setMembershipPeriod(3)"
>
                {{ planPrice(3).regular }} kr<wbr> / kvartal
            </button> -->

            <button class="button-small-checkout" :class="{ active: membership.period == 6 }"
                      @click.capture.prevent="setMembershipPeriod(6)"
>
                {{ planPrice(6).regular }} kr<wbr> / halvår
            </button>
            <button class="button-small-checkout" :class="{ active: membership.period == 1999 }"
                      @click.capture.prevent="setMembershipPeriod(1999)"
>
                {{ planPrice(1999).regular }} kr<wbr> / livstid
            </button>

            </div>

        <!-- SELECT MEMBERHSIP LENGTH  -->
      <div id="swish-membership-length" class="membership-chooser pay-form-box" style="width:100%;" v-show="!membership.period && !swishSubmitted && membership.payment === 'swish'" :class="{ active: !membership.period }">


         
          <button class="button-small-checkout" :class="{ active: membership.period == 2 }"
          @click.capture.prevent="setMembershipPeriod(2)"
          >
               60 dagar<br />
               <span style="font-size: larger;">{{ planPrice(2).regular }} kr</span>
               
              
            </button>

            <!-- <button class="button-small-checkout" :class="{ active: membership.period == 3 }"
                      @click.capture.prevent="setMembershipPeriod(3)"
>
                {{ planPrice(3).regular }} kr<wbr> / kvartal
            </button> -->

            <button class="button-small-checkout" :class="{ active: membership.period == 6 }"
                      @click.capture.prevent="setMembershipPeriod(6)"
>
 Halvår<br />
               <span style="font-size: larger;">{{ planPrice(6).regular }} kr</span>            </button>
            <button class="button-small-checkout" :class="{ active: membership.period == 1999 }"
                      @click.capture.prevent="setMembershipPeriod(1999)"
>
 Livstid<br />
               <span style="font-size: larger;">{{ toSE(planPrice(1999).regular) }} kr</span>
              
              </button>

            </div>
            
<!-- /SELECT MEMBERHSIP LENGTH -->

        <div
          v-show="false && membership.payment == 'stripe' && membership.period"
          class=" pay-form-box" style="width:100%;">




          <button :disabled="!membership.sessionId" class="button-large secondary" style="max-width:200px;justify-self:center;" @click.prevent="finalizeStripePayment">


<div class="spinner" v-show="!membership.sessionId">
<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <circle cx="50" cy="50" r="45"/>
</svg>
</div>

      <span v-show="membership.sessionId" style="line-height:34px;">Aktivera
        
        
        <!-- {{membership.sessionId}} -->
        </span></button>





           <div class="pay-summary-box" v-if="true">


              <stripe-checkout
      ref="checkoutRef"
      :pk="publishableKey"
      :session-id="this.stripeIds[this.membership.period]"
    />
  
              <p v-show="membership.period">
                <!-- Ditt pris är {{ currentPlanPrice }} kronor
                <span v-if="membership.payment == 'swish'">
                  för
                  <span v-if="membership.period == 3">90</span>
                  <span v-if="membership.period == 6">180</span>
                  dagar.
                </span>

                <span v-else>
                  <span v-if="membership.period == 1">var 30:e dag</span>
                  <span v-if="membership.period == 3">var 90:e dag</span>
                  <span v-if="membership.period == 6">var 180:e dag</span>
                  <span v-if="membership.period == 999">varje månad</span>
                  .
                </span> -->

                <span v-if="membership.payment == 'swish'">
                  När du aktiverar ditt medlemskap är det aktivt i
                  {{ membership.period * 30 }} dagar, därefter avsltuas det
                  automatiskt. Om du vill fortsätta använda tjänsten måste du
                  själv aktivt förlänga medlemskapet. <br><br>Genom att
                  klika på "Aktivera" godkänner jag
                  <a href="/">BytBostads Användarvillkor</a> och bekräftar att
                  jag har läst <a href="/">BytBostads Dataskyddspolicy</a>.
                </span>
                <span v-else>
                  När du aktiverar ditt medlemskap påbörjas ett abonnemang utan
                  bindningstid. Du kan avsluta abonnemanget när som helst med
                  ett klick. Om du inte avslutat abonnemanget innan periodens slut
                  förlängs det automatiskt. <br><br>
                  Genom att klika på "aktivera" godkänner jag <router-link :to="{ name: 'terms'}" target="_blank">BytBostads Användarvillkor och datapolicy</router-link>.  
                </span>
              </p>
            </div>

            

         


          <!-- <CreditCardForm :stripe="stripeKey" /> -->
        </div>

        <!-- Swish form -->
        <div
          v-show="membership.period"
          class="">
          <!-- Swish switch -->
          <div
            v-if="membership.period == 0"
            class="pay-form-box">
            <p>
              För att betala med Swish behöver du välja 3 eller 6 månaders
              medlemskap.
            </p>
            <button
              class="button secondary"
              @click.prevent="membership.period = 3">
              Byt till 3 månader
            </button>
            <button
              class="button secondary"
              @click.prevent="membership.period = 6">
              Byt till 6 månader
            </button>
          </div>

          <!-- Swish enter phone nr -->
          <div
          id="payment-details-final-box"
            v-else
            class="pay-form-box active"
            style="position:relative;"
            >
            
            <button style="position:absolute;top:10px;right:10px;text-decoration: underline;color: #5B5B5B;cursor:pointer;" v-show="qrCodeUrl && membership.payment === 'swish'" @click.prevent="resetSwish">Avbryt</button>
            
            <!-- <FloatLabel>
              <input
                v-model="membership.swishnumber"
                type="tel"
                placeholder="Mobilnummer">
            </FloatLabel> -->

            <!-- Swish QR Code -->
          <button v-if="qrCodeUrl && membership.payment === 'swish'" @click.prevent="openSwishApp" class="hide-for-medium button-submit secondary">
            Öppna Swish Appen
          </button>
          <div v-if="membership.payment === 'swish' && (swishSubmitted || qrCodeUrl)" style="
    display: grid;
    place-content: center;
    height:300px;
"

class="show-for-medium">

<div class="spinner-secondary" v-show="!qrCodeUrl">
<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <circle cx="50" cy="50" r="45"/>
</svg>
</div>


            <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="Swish QR Code" class="show-for-medium" style="width:300px;height:300px;max-width:100%;" />
          </div>
          <!-- /Swish QR Code -->


            <!-- {{ validatedPhoneNumber }} -->
            <div class="pay-summary-box">
              <h3 v-if="!swishSubmitted">Totalbelopp ink moms</h3>
              <h2 v-if="!swishSubmitted">{{ toSE(currentPlanPrice) }} SEK</h2>





          <button class="button-submit secondary" style="max-width:200px;justify-self:center;" v-if="membership.payment === 'swish' && !swishSubmitted" @click.prevent="finalizeSwishPayment">
            <span style="line-height:34px;">Aktivera</span>
          </button>


          




          <button v-if="membership.payment == 'stripe'" :disabled="!membership.sessionId" class="button-submit secondary" style="max-width:200px;justify-self:center;" @click.prevent="finalizeStripePayment">
            <div class="spinner" v-show="!membership.sessionId">
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="45"/>
              </svg>
            </div>
            <span v-show="membership.sessionId" style="line-height:34px;">Aktivera</span>
          </button>




              <p>
                Ditt pris är {{ currentPlanPrice }} kronor
                <span v-if="membership.payment == 'swish'">
                  <span v-if="membership.period == 2">för 60 dagar</span>
                  <span v-if="membership.period == 3">för 90 dagar</span>
                  <span v-if="membership.period == 6">för 180 dagar</span>
                  <span v-if="membership.period == 1999">för resten av livet</span>.
                </span>

                <span v-else>
                  <span v-if="membership.period == 1">var 30:e dag</span>
                  <span v-if="membership.period == 3">90:e</span>
                  <span v-if="membership.period == 6">180:e</span>
                  <span v-if="membership.period == 1999">för resten av livet</span>.

                </span>

                <span v-if="membership.payment == 'swish' && membership.period != 1999">
                  När du aktiverar ditt medlemskap är det aktivt i
                  {{ membership.period * 30 }} dagar, därefter avslutas det
                  automatiskt. Om du vill fortsätta använda tjänsten måste du
                  själv aktivt förlänga medlemskapet. <br><br>Genom att
                  klika på "aktivera" godkänner jag
                <router-link :to="{ name: 'terms'}" target="_blank">BytBostads Användarvillkor och datapolicy</router-link>.
                </span>
                <span v-else-if="membership.period == 1999">
                  Du kan använda medlemskapet så länge du vill, utan begränsningar. Du kan radera din annons och lägga in en annan annons i framtiden, utan att behöva betala på nytt.
                 <br><br>Genom att
                  klika på "aktivera" godkänner jag
                  <router-link :to="{ name: 'terms'}" target="_blank">BytBostads Användarvillkor och datapolicy</router-link>.
                </span>
                <span v-else>
                  När du aktiverar ditt medlemskap påbörjas ett abonnemang utan
                  bindningstid. Du kan avsluta abonnemanget när som helst med
                  ett klick. Om du inte avslutat abonnemanget vid periodens slut
                  förlängs det automatiskt. <br><br>Genom att klika på
                  "aktivera" godkänner jag
                  <router-link :to="{ name: 'terms'}" target="_blank">BytBostads Användarvillkor och datapolicy</router-link>.
                </span>
              </p>
            </div>

            <!-- <div class="grid-x grid-margin-x align-right">
              <div class="cell small-12 medium-6">
                <button class="button-submit secondary">Betala</button>
              </div>
            </div> -->
          </div>
        </div>
        <!-- Swish form : END -->
        <!-- Invoice form -->
        <div
          v-if="membership.payment == 'billogram'"
          class="cell small-12">
          <div class="pay-form-box">
            <div class="grid-x grid-margin-x">
              <!-- <div class="cell small-6 box" :class="{ active: membership.invoiceHow == 'email' }" @click="membership.invoiceHow = 'email'" >
              <input id="invoice_email" v-model="membership.invoiceHow" type="radio" name="invoice_how" value="email" required />
              <label for="invoice_email">Epost (+0 kronor)</label>
            </div>

            <div class="cell small-6 box" :class="{ active: membership.invoiceHow == 'post' }" @click="membership.invoiceHow = 'post'" >
              <input id="invoice_post" v-model="membership.invoiceHow" type="radio" name="invoice_how" value="post" />
              <label for="invoice_post">Pappersfaktura (+25 kronor / faktura)</label>
            </div> -->

              <div class="cell small-6">
                <div
                  class="radio-wrap twoline"
                  :class="{ active: membership.invoiceHow == 'email' }"
                  @click="membership.invoiceHow = 'email'">
                  <div class="radio-box"></div>
                  <div class="radio-label">
                    Epostfaktura <span>(+0 kronor)</span>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>

              <div class="cell small-6">
                <div
                  class="radio-wrap twoline"
                  :class="{ active: membership.invoiceHow == 'post' }"
                  @click="membership.invoiceHow = 'post'">
                  <div class="radio-box"></div>
                  <div class="radio-label">
                    Pappersfaktura <span>(+25 kronor / faktura)</span>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>

              <!-- <div class="cell small-12">
              <h3>Betalningsmottagare</h3>
            </div> -->

              <div class="cell small-12">
                <FloatLabel>
                  <input
                    v-model="user.email"
                    type="text"
                    placeholder="Epost">
                </FloatLabel>
              </div>

              <div class="cell small-12 medium-6">
                <FloatLabel>
                  <input
                    v-model="user.firstname"
                    required
                    type="text"
                    placeholder="Förnamn"
                    maxlength="100">
                </FloatLabel>
              </div>

              <div class="cell small-12 medium-6">
                <FloatLabel>
                  <input
                    v-model="user.lastname"
                    required
                    type="text"
                    placeholder="Efternamn"
                    maxlength="100">
                </FloatLabel>
              </div>

              <div class="cell small-12">
                <FloatLabel>
                  <input
                    v-model="user.street_address"
                    type="text"
                    placeholder="Adress"
                    maxlength="100">
                </FloatLabel>
              </div>

              <div class="cell small-12">
                <FloatLabel>
                  <input
                    v-model="user.careof"
                    type="text"
                    placeholder="c/o"
                    maxlength="100">
                </FloatLabel>
              </div>

              <div class="cell small-12 medium-4">
                <FloatLabel>
                  <input
                    v-model="user.zipcode"
                    type="text"
                    placeholder="Postnummer"
                    maxlength="5">
                </FloatLabel>
              </div>

              <div class="cell small-12 medium-8">
                <FloatLabel>
                  <input
                    v-model="user.city"
                    type="text"
                    placeholder="Postort"
                    maxlength="30">
                </FloatLabel>
              </div>

              <div class="cell small-12 pay-summary-box">
                <h3>Totalbelopp ink moms</h3>
                <h2>{{ currentPlanPrice }} SEK</h2>
                <button class="button-submit secondary" :disabled="billogramSubmitted" @click.prevent="billogramPay">
                  Slutför köp
                </button>

                <p>
                  Ditt pris är {{ currentPlanPrice }} kronor
                  <span v-if="membership.payment == 'swish'">
                    för
                    <span v-if="membership.period == 3">90</span>
                    <span v-if="membership.period == 6">180</span>
                    dagar.
                  </span>

                  <span v-else>var
                    <span v-if="membership.period == 1">30:e</span>
                    <span v-if="membership.period == 3">90:e</span>
                    <span v-if="membership.period == 6">180:e</span>
                    <span v-if="membership.period == 1999">30:e</span>
                    dag.
                  </span>

                  <span v-if="membership.payment == 'swish'">
                    När du aktiverar ditt medlemskap är det aktivt i
                    {{ membership.period * 30 }} dagar, därefter avsltuas det
                    automatiskt. Om du vill fortsätta använda tjänsten måste du
                    själv aktivt förlänga medlemskapet. <br><br>Genom att
                    klika på "slutför köp" godkänner jag
                    <a href="/">BytBostads Användarvillkor</a> och bekräftar att
                    jag har läst <a href="/">BytBostads Dataskyddspolicy</a>.
                  </span>
                  <span v-else>
                    När du aktiverar ditt medlemskap påbörjas ett abonnemang utan
                    bindningstid. Du kan avsluta abonnemanget när som helst med
                    ett klick. Om du inte avslutat abonnemanget vid periodens
                    slut förlängs det automatiskt. <br><br>Genom att klika
                    på "slutför köp" godkänner jag
                    <router-link :to="{ name: 'terms'}" target="_blank">
                      BytBostads Användarvillkor och datapolicy
                    </router-link>.
                  </span>
                </p>
              </div>

              <!-- <div class="cell small-12 medium-6">
                <button class="button-submit secondary" @click="billogramPay">Betala</button>
              </div> -->
            </div>
          </div>
        </div>
        <!-- Invoice form : END -->
      </div>
    </section>
    <!-- Select payment : END -->


















    <!--

    <div class="small-12 cell">
      <h3>Inga dolda avifter</h3>
      <p>
        Ditt pris är {{ currentPlanPrice }} kronor
        <span v-if="membership.payment == 'swish'">
          för
          <span v-if="membership.period == 3">90</span>
          <span v-if="membership.period == 6">180</span>
          dagar.
        </span>

        <span v-else
          >var
          <span v-if="membership.period == 1">30:e</span>
          <span v-if="membership.period == 3">90:e</span>
          <span v-if="membership.period == 6">180:e</span>
          dag.
        </span>

        <span v-if="membership.payment == 'swish'"
          >När du aktiverar ditt medlemskap är det aktivt i
          {{ membership.period * 30 }} dagar, därefter avsltuas det automatiskt.
          Om du vill fortsätta använda tjänsten måste du själv aktivt förlänga
          medlemskapet.</span
        >
        <span v-else
          >När du aktiverar ditt medlemskap påbörjas ett abonnemang utan
          bindningstid. Du kan avsluta abonnemanget när som helst med ett klick.
          Om du inte avslutat abonnemanget vid periodens slut förlängs det
          automatiskt.</span
        >
      </p>
    </div> -->
  </div>
</template>

<script>
import PayService from '@/services/PayService.js'
import { track, exVat } from '@/utils/track'
import SwishService from '@/services/SwishService.js';
import { StripeCheckout } from '@vue-stripe/vue-stripe';

import { parsePhoneNumber } from 'awesome-phonenumber'


import { mapGetters } from 'vuex'
// import CreditCardForm from '@/components/CreditCardForm.vue'
import { stripeKey, stripeOptions } from '@/stripeConfig.json'
import FloatLabel from '@/components/FloatLabels.vue'
import { bool } from 'joi';
// import { stripeSDK } from '@/mixins/stripe-sdk.js'

// import { StripeCheckout } from 'vue-stripe-checkout';




const PRICE_ONE_MONTH = 129;
const PRICE_ONE_QUARTER = 279;
const PRICE_60_DAYS = 249;
const PRICE_SIX_MONTHS = 599;
// const PRICE_ONE_YEAR = 999;
const PRICE_LIFETIME = 2495;

export default {
  // mixins: [stripeSDK],
  components: {
    StripeCheckout,
    // StripeCheckout,
    // CreditCardForm,
    FloatLabel
  },
  data() {
    return {
      swishPaymentID: null,
      swishToken: null,
      stripeIds: [],
      iAmAware: false,
      imAwareReadMore: false,
      sessionId: '',
      loading: false,
      showall: true,
      billogramSubmitted: false,
      swishSubmitted: false,
      cardnumber: '',
      stripeisready: false,
      stripeisloading: false,
      cardData: { name: '' },
      stripe: {},
      elements: {},
      stripeKey: stripeKey,
      publishableKey: stripeKey,
      stripeOptions: stripeOptions,
      complete: false,
      options: {},
      qrCodeUrl: '',
      paymentCheckInterval: null,
      membership: {
        bigCities: true,
        period: null,
        discount: false,
        payment: null,
        invoiceHow: 'email',
        sessionId: '',
        swishnumber: null
        // firstname: this.$store.getters.user.firstname
      },
      items: [
      {
    "plan": "price_1SuvWJHmnAqPxmy3SM57KwBU",
    "quantity": 1
  },
    ],
    successUrl: 'https://localhost:8080/konto?status=ja',
    cancelUrl: 'https://localhost:8080/betala',
    
  }},

  watch: {
    membership: {
      handler (newValue, oldValue) {

        const isSwish = newValue.payment === 'swish'
        const currentPeriod = newValue.period


        const changedPaymentMethod = newValue.payment !== oldValue.payment;


        if(changedPaymentMethod){
          console.log('Payment method changed, resetting period');
          this.resetSwish()
        }

        // console.log({isSwish, currentPeriod})

        // if(isSwish && !currentPeriod){
        //        this.$nextTick(() => {
        //       console.log('Scrolling to swish membership length');
        //       const x = this.$scrollTo('#swish-membership-length', 300, {    offset: -72,});
        //        });
      
        // }

        if(isSwish && currentPeriod === 1){
          this.membership.period = 2;
        }
        if(!isSwish && currentPeriod === 2){
          this.membership.period = 1;
        }

        // console.log('membership handler', newValue.payment)
        // console.log('membership handler', newValue.period)
        // console.log('Photo handler watch', this.photo);
        // if(newPhoto.display !=== 0){
        // newValue.display && this.updateForm();
        // }
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters(['user']),

    normalizedPhoneNumber(){
      if(this.membership.swishnumber){
        const pn = parsePhoneNumber(this.membership.swishnumber, {regionCode: 'SE'});
        

        // console.log('Phone number check:', pn);
        if(pn.valid){
          return pn.number.e164.replace('+','');
        }else{
          return this.membership.swishnumber;
        }
      }
      return null;
    },
    // validatedPhoneNumber(){
    //   const pn = parsePhoneNumber(this.membership.swishnumber, {regionCode: 'SE'});
    //   return pn;
    // },


    currentPlanPrice() {
      var plan = this.membership.period
      var price = PRICE_ONE_MONTH
      switch (plan) {
        case 2:
          price = PRICE_60_DAYS
          break
        case 3:
          price = PRICE_ONE_QUARTER;
          break
        case 6:
          price = PRICE_SIX_MONTHS;
          break
        case 1999:
          price = PRICE_LIFETIME;
          break
      }

      if (this.membership.discount) {
        price = Math.floor(price / 2)
      }

      if (
        this.membership.payment === 'billogram' &&
        this.membership.invoiceHow === 'post'
      ) {
        price = price + 25
      }
      return price
    }
  },
  methods: {
    // One place for the purchase conversion, so all three payment methods
    // report identically. `value` + `currency` are what Google Ads needs to
    // report return on ad spend per campaign.
    //
    // `value` is EX VAT. Every revenue report — PostHog Revenue Analytics, the
    // marketing conversion goal, the `memberships` table — is on an ex-VAT
    // basis, and mixing the two is how you end up quoting revenue 25% high.
    // `currentPlanPrice` is the gross price the customer pays ("Totalbelopp
    // ink moms"), so VAT is divided out here. VAT is a flat 25% on every sale.
    trackPurchase (paymentMethod) {
      track('membership_purchased', {
        value: exVat(this.currentPlanPrice),
        currency: 'SEK',
        plan_period: this.membership.period,
        payment_method: paymentMethod,
        discounted: !!this.membership.discount
      })
    },

    beforeRouteLeave(to, from, next) {
  // Save immediately when leaving (don't wait for timeout)
  this.saveFiltersImmediately()
    .then(() => next())
    .catch(() => next());
},

beforeDestroy() {
  // Clear timeout
  if (this.saveTimeout) {
    clearTimeout(this.saveTimeout);
  }
  
  // Clean up listeners
  window.removeEventListener('resize', this.handleResize);
},

nicePeriodName(period){
      switch(period){
        case 1:
          return '1 månad';
        case 2:
          return '60 dagar';
        case 3:
          return '3 månader';
        case 6:
          return '6 månader';
        case 1999:
          return 'Livstid';
        default:
          return period;
      }
    },
    nicePaymentName(paymentMethod){
      switch(paymentMethod){
        case 'stripe':
          return 'Kortbetalning';
        case 'swish':
          return 'Swish';
        case 'billogram':
          return 'Faktura';
        default:
          return paymentMethod;
      }
    },

    resetPeriod(){
      this.membership.period = null;
      this.resetSwish();
    },
    resetPayment(){
      this.resetPeriod();
      this.resetSwish();
      this.membership.payment = null;
    },

    handleVisibilityChange() {
      if (!document.hidden) {
        // Page is now visible - refresh payment status
        // this.refreshPaymentStatus();
        console.log('Page visible again, refreshing user data...');
        this.$store.dispatch('getMe').catch(() => {})
        this.$store.dispatch('getMemberships').catch(() => {})
      }
    },
    
    // async refreshPaymentStatus() {
    //   // Your logic to check payment status
    //   console.log('Checking payment status...');
    //   // await this.fetchPaymentStatus();
    // },
  
    checkPhoneNumber(){
      if(this.membership.swishnumber){
        const pn = parsePhoneNumber(this.membership.swishnumber, {regionCode: 'SE'});
        if(pn.valid){
          // console.log('Valid number:', pn.getNumber('e164'));
          this.membership.swishnumber = pn.number.e164.replace('+','');
        }else{
          console.log('Invalid number');
        }
      }
    },  

    toSE(amount) {
        if (typeof amount !== 'number') return amount;
        return amount.toLocaleString('sv-SE', {
                minimumFractionDigits: 0
        });
},

    finalizeStripePayment(){
      // console.log('Lets pay')
      this.$refs.checkoutRef.redirectToCheckout()
    },




    // fetchStripeSession(){
    //   console.log('Clearning the session ID')
    //   // this.membership.sessionId = false;
     
    // if(!this.membership.sessionId){
     
    // }






openSwishApp(){

  if(this.swishToken){
    const swishUrl = `swish://paymentrequest?token=${this.swishToken}`;
    window.location = swishUrl;
}
},




    finalizeSwishPayment(){

      this.swishSubmitted = true;
  if(this.membership.swishnumber){
    const pn = parsePhoneNumber(this.membership.swishnumber, {regionCode: 'SE'});
    if(!pn.valid){
      alert('Ange ett giltigt mobilnummer för Swish');
      return;
    }
  }
  
  SwishService.createSwishPayment({plan: this.membership.period}).then(response =>{
    console.log('Swish payment created:', response.data);

    if(response.data.qr){
      this.qrCodeUrl = response.data.qr;
    }
    
    this.swishPaymentID = response.data.id;
    this.swishToken = response.data.token;
    // Start checking the payment status
    this.checkPaymentStatus(this.swishPaymentID);

  }).catch(error =>{
    Sentry.captureException(error);
  })
},

checkPaymentStatus(paymentId){
  const startTime = Date.now();
  const maxDuration = 3 * 60 * 1000; // 3 minutes in milliseconds
  
  const intervalId = setInterval(() => {
    // Check if 3 minutes have passed
    if(Date.now() - startTime >= maxDuration){
      clearInterval(intervalId);
      console.log('Payment check timeout after 3 minutes');
      this.handlePaymentTimeout();
      return;
    }
    
    // Check payment status
    SwishService.checkPayment({id: paymentId}).then(response => {
      const status = response.data.status;
      
      if(status === 'PAID'){
        clearInterval(intervalId);
        this.handlePaymentSuccess(response.data);
      } else if(status === 'CREATED'){
        // Keep waiting, do nothing
        // console.log('Payment still pending...');
      } else {
        // Any other status (DECLINED, CANCELLED, ERROR, etc.)
        clearInterval(intervalId);
        this.handlePaymentFailure(status, response.data);
      }
    }).catch(error => {
      clearInterval(intervalId);
      Sentry.captureException(error);
      this.handlePaymentError(error);
    });
    
  }, 5000); // Check every 5 seconds
  
  // Store intervalId if you need to cancel it from elsewhere
  this.paymentCheckInterval = intervalId;
},

handlePaymentSuccess(data){
  console.log('Payment successful!', data);
  this.trackPurchase('swish');
  // this.$store.dispatch('getMemberships')
  this.$store.dispatch('getMe').catch(() => {})
  this.$store.dispatch('getMemberships').catch(() => {})
  // Do stuff when payment is successful
},

handlePaymentFailure(status, data){
  console.log('Payment failed with status:', status, data);
  // Handle failed/declined/cancelled payments
  this.resetSwish();
  this.membership.period = null;
  this.membership.payment = null;
},

handlePaymentTimeout(){
  console.log('Payment check timed out');
  // Handle timeout scenario
  this.resetSwish();
      this.membership.period = null;
  this.membership.payment = null;
},
handlePaymentError(error){
  console.log('Error checking payment status', error);
  this.resetSwish();

    this.membership.period = null;
  this.membership.payment = null;
  // Handle API errors
},


resetSwish(){

  this.swishSubmitted = false;
  this.swishPaymentID = null;
  this.qrCodeUrl = '';
  if(this.paymentCheckInterval){
    clearInterval(this.paymentCheckInterval);
    this.paymentCheckInterval = null;
  }
},














    checkPayment(id){
      SwishService.checkPayment(id).then(response =>{
        console.log('Payment status:', response.data);
      }).catch(error =>{
        Sentry.captureException(error);
      })
    },

    getStripeSession(){

      // PayService.getStripeSession(this.membership.period).then(x =>{
      //  this.sessionId = x.data.data
      //  this.$refs.checkoutRef.redirectToCheckout()
      // })

    },

    setMembershipPeriod(period){

//  this.$nextTick(() => {
//       this.$scrollTo('#payment-details-final-box', 300, {    offset: -72,});
//  });
      // console.log('Period: ' + this.stripeIds[this.membership.period]);
    // console.log('Clearing ID')
    // console.log('Fetching new session ID for period ' + this.membership.period);

    this.resetSwish();
    this.membership.sessionId = false;
    this.membership.period = period;
     this.imAwareReadMore = false;
     this. iAmAware = false;
    //  this.fetchStripeSession()

if(!this.stripeIds[this.membership.period]){

  // console.log(this.membership);
      PayService.getStripeSession(this.membership.period).then(x =>{
       this.membership.sessionId = x.data.data
        this.stripeIds[this.membership.period] = x.data.data;
      //  console.log('Got an ID', x.data.data)
      //  this.$refs.checkoutRef.redirectToCheckout()
      
      }).catch(error =>{
        Sentry.captureException(error);
      })

      }else{
       this.membership.sessionId = this.stripeIds[this.membership.period]


      }
    },

    checkout () {
      this.$refs.checkoutRef.redirectToCheckout({
        customerEmail: 'fabian@bopunkten.se'
      });
    },

    gotToken(token) {
      let paymentDetails = { token, plan: this.membership.period }

      PayService.paytithStripe(paymentDetails).then(response => {
        // console.log(response.data)
        this.trackPurchase('stripe')
        this.stripeisloading = false
        this.stripeisready = true
      }).catch(error => {
        // console.log(error)
        this.stripeisloading = false
        this.stripeisready = true
        this.stripeerror = true
      })
      // alert('Vi fick token')
      // console.log(val)
    },
    stripeError() {
      this.stripeisloading = false
    },
    stripeLoading() {
      this.stripeisready = false
      this.stripeisloading = true
    },
    stripeComplete(val) {
      this.stripeisready = val
      // console.log('Stripe is complete')
    },
    stripePay() {
      this.stripeLoading()
      this.$refs.stripe.pay()
    },
    billogramPay() {
      // console.log('Pay with Billogram')
      // console.log(this.user)
      this.billogramSubmitted = true

      this.$store
        .dispatch('updateMe', this.user)
        .then(() => {
          this.formHasChanged = false
          this.formSuccess = true
          // console.log(res.data)
          this.$store.dispatch('getMe').then(() => {
            // console.log('Updated the user...')
            let discountCode = ''
            if (this.membership.discount) {
              discountCode = 'oldmember'
            }
            let paymentDetails = { plan: this.membership.period, invoiceHow: this.membership.invoiceHow, discount_code: discountCode }

            // console.log(paymentDetails);
            PayService.payWithBillogram(paymentDetails).then(() => {
              // console.log(response.data)
              this.trackPurchase('billogram')
              // this.stripeisloading = false
              // this.stripeisready = true

              this.$store.dispatch('getMe').catch(() => {})
              this.$store.dispatch('getMemberships').catch(() => {})
            }).catch(error => {
              // console.log(error)
              this.billogramSubmitted = false
              this.stripeisloading = false
              this.stripeisready = true
              this.stripeerror = true
              throw error
            })
          }).catch(() => {})
        })
        .catch(() => {
          // console.log('Nope')
        })
    },
    planPrice(plan) {
      //   var plan = this.membership.period
      var price = { regular: PRICE_ONE_MONTH }
      switch (plan) {
        case 2:
          price.regular = PRICE_60_DAYS
          break
        case 3:
          price.regular = PRICE_ONE_QUARTER
          break
        case 6:
          price.regular = PRICE_SIX_MONTHS
          break
        case 1999:
          price.regular = PRICE_LIFETIME;
          break
      }
      if (this.membership.discount) {
        price.discount = Math.floor(price.regular / 2)
      }
      return price
    },
   
  },
   mounted(){
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    
     //  this.setMembershipPeriod(1);
  },
  beforeDestroy(){
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);

  if(this.paymentCheckInterval){
    
    clearInterval(this.paymentCheckInterval);
  }
}
  
}
</script>

<style lang="scss" scoped>
@import '@/scss/main.scss';



.clickable{
  margin:0px;
  padding:0px;
}
.klickable, .klickable  *{
  cursor:pointer;
}
input[type='checkbox'],
input[type='radio'] {
  display: none;
}

button[disabled]{
     opacity: 0.4;
    cursor: not-allowed !important;
}

.package-section .package-type-wrap .price.strike{
  text-decoration: line-through;
}

//TODO: Style the disscount box properly
.box{
  border: 3px solid #f6f6f6;

  border-radius: 5px;
    // background-clip: padding-box;
    padding: 10px;
    // text-align: center;
    // height: 100%;
    //TODO: set a proper margin bottom
    margin-bottom:20px;
    cursor:pointer;
}

.box p{
font-size: 16px;
    color: #5B5B5B;
    font-weight: 400;
}
.box h1{
  color: #121212;
    font-weight: 700;
    line-height: 20px;
    margin-top: 16px;
}

.discount.active{
  border-color:$color-secondary;
}

.pay-summary-box p{
font-size: 14px;
    line-height: 18px;
    color: #5B5B5B;
    font-weight: 400;
    padding: unset;
}

.box.imaware{
  display:grid;
// background-color: #FF7765;
// color:white;
  // border:2px solid#FF7765;
  border-color: #FF7765;

  margin-top:20px;
  cursor: unset;
  
  p, h1, h2, h3, h4{
    margin-bottom: 5px;
  }
  .link{
    cursor:pointer;

    width:unset;
    text-decoration: underline;
    color:#FF7765
    
  }


 
}


 .imaware.active{
  border-color:var(--color-secondary);
  }


.box.imaware .radio-wrap.active .radio-box{
//  background-color: #FF7765;


}

.imaware .button{
  // place-self: center;
  // max-width:200px;
  // justify-self:center;
}





.spinner{
  
  // SVG styles.
svg {
  height:30px;
  animation: .3s linear infinite svg-animation;
  max-width: 100px;
}

// SVG animation.
@keyframes svg-animation {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg)
  }
}

// Circle styles.
circle {
  animation: 3s ease-in-out infinite both circle-animation;
  display: block;
  fill: transparent;
  // stroke: #2f3d4c;
  stroke:#fff;
  stroke-linecap: round;
  stroke-dasharray: 283;
  stroke-dashoffset: 280;
  stroke-width: 10px;
  transform-origin: 50% 50%;
}

// Circle animation.
@keyframes circle-animation {
  0%,
  25% {
    stroke-dashoffset: 75;
    transform: rotate(0);
  }
  
  // 50%,
  // 75% {
  //   stroke-dashoffset: 75;
  //   // transform: rotate(45deg);
  // }
  
  100% {
    stroke-dashoffset: 75;
    transform: rotate(360deg);
  }
}
}

.spinner-secondary{
  
  // SVG styles.
svg {
  height:30px;
  animation: .3s linear infinite svg-animation;
  max-width: 100px;
}

// SVG animation.
@keyframes svg-animation {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg)
  }
}

// Circle styles.
circle {
  animation: 3s ease-in-out infinite both circle-animation;
  display: block;
  fill: transparent;
  stroke: #2f3d4c;
  // stroke:#fff;
  stroke-linecap: round;
  stroke-dasharray: 283;
  stroke-dashoffset: 280;
  stroke-width: 10px;
  transform-origin: 50% 50%;
}

// Circle animation.
@keyframes circle-animation {
  0%,
  25% {
    stroke-dashoffset: 75;
    transform: rotate(0);
  }
  
  // 50%,
  // 75% {
  //   stroke-dashoffset: 75;
  //   // transform: rotate(45deg);
  // }
  
  100% {
    stroke-dashoffset: 75;
    transform: rotate(360deg);
  }
}
}


.imaware:not( .active) button[disabled]{
  background-color: red;;
}


.button-small-checkout{
  padding:8px;
  align-items: center;;
  display:grid;
  background-color: #64BCB2;
    // color: #ffffff;

    transition: all 200ms ease-in-out;
    width: 100%;
    // height: 43px;
    // line-height: 43px;
    font-size: 16px;
    font-weight: 700;
    border-radius: 4px;
    background-clip: padding-box;
    background-color: #F6F6F6;
    // color: #B1B1B1;
    cursor: pointer;

    border:2px solid #64BCB2;
    color: #5B5B5B!important;

    &.active{
      background-color: #64BCB2;
      color:#ffffff!important;
      &:hover{background-color:lighten($color-secondary, 10%); color:#ffffff!important;}

      }

      gap: 0.3rem;


  }

  .membership-chooser{
display:grid;

grid-template-columns: 1fr 1fr 1fr;


  @media screen and (max-width: 650px) {
grid-template-columns: 1fr;
    
  }


gap:20px;
    }


    .usp-container{
      display:grid;
      // grid-template-columns: 1fr 1fr;;
    }

    .usp-list{
          grid-template-columns:1fr 1fr 1fr;
           @include breakpoint(small down){
          grid-template-columns:1fr;
        }
      display:grid;
      align-content: center;
      gap: 20px;
      // margin-top:20px;
      // justify-items:center;
      // justify-content: space-around;
      margin-bottom:20px;
      
    }





   

    .usp-list div:before{
      // color:red;
      content: '✓ ';
      font-size:20px;
      color: var(--color-secondary);
    }

    .usp-list div{
          font-family: 'Nunito';
    font-weight: 300;
    font-size: 14px;
    /* text-align: left; */
    padding: 12px;
    place-items: center;
    /* place-items: center; */
    /* align-content: center; */
    display: grid;
    grid-template-columns: auto 1fr;
    gap:10px;
    // background-color:#f6f6f6;
    // border-radius: 5px;
    
    }


    .highlight{
      color:var(--color-primary);
      // font-weight:700;
      // text-decoration:underline;
    }


    ul.membership-bigcities li{
      text-decoration: line-through;
      display:flex;
      gap:10px;
      
      // .check-box{
      //   background-color: red;
      //   fill: white;
      // }
      &:before{
          // content: '🛑'
      }
    }

    ul.membership-bigcities li.active{
            text-decoration: auto;

    &:before{
          // content: '✅'
    }
    }


    .activate-heading{
      text-align: center;
      font-size: 40px;
      margin-bottom:20px;
      padding:10px;
      @include breakpoint(small down){

                    font-size:24px;


                  }
      // background-color: var(--color-secondary);
      // color:white;
      // border-radius:5px;
      // color:#5B5B5B;
      // border-bottom:2px solid var(--color-secondary);
    }


    .payment-type-wrap{
      flex-grow: 1;
    }

    .payment-logo{
      display:none;
    }

    

    .pay-form-box{
    border:3px solid #f6f6f6;
    background-color: #fff;
    @include br(5px);
    margin-top:20px;
    padding:30px;
    margin-left:0.625rem;margin-right:0.625rem;
    input[type="text"],.radio-wrap{
      margin-bottom:20px;
    }

     @include breakpoint(small down){ 
        padding: 10px;
    }
    &.active{
      border-color:$color-secondary;
}
    }
</style>
